const en={
    translation: {
        pages:{
            "admin":"Administrating",
            "guide":"User's guide",
            "license":"License",
            "support":"Support",
        },
        swal:{
            "yep":"Yes",
            "nope":"No, cancell",
        }
    }
}
export default en;